module.exports = __webpack_public_path__ + "static/media/task.16489ca9.svg";